/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';
import NumberArrow from 'solis/react/primitive/number.arrow';


const getName = ({ colony }) =>
{
  return colony.getName();
};


const getAuthorityText = ({ colony, authority }) =>
{
  return authority.getCurrentValue(colony);
};


const getScoredText = ({ colony, authority }) =>
{
  return authority.getNextValue(colony);
};


const getPartialText = ({ colony, authority }) =>
{
  return '+' + authority.getNextIncrease(colony);
};


const Row = (props) =>
(
  <Flex justify = 'between' align = 'center' gap = '3'>

    <Text.Body>{getName(props)}</Text.Body>
    {props.children}

  </Flex>
);


export const Scored = (props) =>
(
  <Row colony = {props.colony}>

    <NumberArrow size = '2' width = {props.width}>
      <NumberArrow.Left>{getAuthorityText(props)}</NumberArrow.Left>
      <NumberArrow.Right accent weight = 'bold'>{getScoredText(props)}</NumberArrow.Right>
    </NumberArrow>

  </Row>
);


export const Partial = (props) =>
(
  <Row colony = {props.colony}>

    <Text.Body color = 'gray'>{getPartialText(props)}</Text.Body>

  </Row>
);
